<template>
  <div class="row card-holder-embedded gy-4" v-images-loaded="layout">
    <slot name="content">
      ...
    </slot>
  </div>
</template>
<script>
import Masonry from "masonry-layout/Masonry";
import imagesLoaded from "vue-images-loaded";

export default {
  name: "social-posts",
  components: {},
  directives: { imagesLoaded },
  data() {
    return {
      msnry: {},
    };
  },
  mounted() {
    this.msnry = new Masonry(".card-holder-embedded", {
      percentPosition: true,
    });
    this.$nextTick(() => {
      this.msnry.layout();
    });
    window.msnry = this.msnry;
  },
  methods: {
    layout() {
      this.msnry.layout();
    },
  },
};
</script>